module.exports = "https://web-assets.ifttt.com/packs/media/energy_challenge/logo-lifx-66316b98.png";